export class Eula {
  public id: string;
  public documentUrl: string;
  public effectiveStartDate: Date;

  constructor(id: string, effectiveStartDate: Date) {
    this.id = id;
    this.effectiveStartDate = effectiveStartDate;
  }

  static parse(obj: any): Eula {
    if (!obj) return;
    return new Eula(obj.id, obj.effectiveStartDate);
  }
}
